import {
	Button,
	createTheme,
	Link,
	Pagination,
	Paper,
	Slide,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	ThemeProvider,
	Typography,
	useMediaQuery,
} from "@mui/material"
import React, { useContext, useEffect, useState } from "react"
import { firebaseTimeStampToDate, formatLicenseNumber, statuses } from "../util/helpers"
import { AdminContext } from "../views/Admin"
import FilterListIcon from "@mui/icons-material/FilterList"
import { adminApproveDenyQuestionV2, adminGetQuestionsForApprovalV2 } from "../util/firebase"
import { ScrollTopButton } from "./Posts"
import scrollTopIcon from "../assets/scrollTopIcon.svg"
import AnswerQuestionDialog from "./AnswerQuestionDialog"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
	direction: "rtl",
})

const questionCols = [
	{ label: "מודעה", field: "licenseNumber", type: "license" },
	{ label: "משתמש", field: "userId", type: "userid" },
	{ label: "שאלה", field: "question", type: "text" },
	{ label: "ת. פרסום", field: "createDateTime", type: "datetime" },
	/* { label: "סטטוס", field: "status", type: "status" },
	{ label: "יצרן", field: "make", type: "text" },
	{ label: "דגם", field: "model", type: "text" },
	{ label: "שנה", field: "year", type: "text" },
	{ label: "מחיר מינימום", field: "reservePrice", type: "currency" },
	{ label: "מחיר רכישה מיידית", field: "buyNowPrice", type: "currency" },
	{ label: "תחילת מכירה", field: "startDateTime", type: "datetime" }, */
]

const Questions = ({ containerRef }) => {
	const adminContext = useContext(AdminContext)
	const handlePostOptionOpen = adminContext.handlePostOptionOpen
	const handleUserDialogOpen = adminContext.handleUserDialogOpen
	const handleOpenSnackbar = adminContext.handleOpenSnackbar

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))
	const [sort, setSort] = useState({})
	const [questions, setQuestions] = useState([])

	const [page, setPage] = useState(1)
	//const [lastTimeStamp, setLastTimeStamp] = useState(null)
	const [pageCount, setPageCount] = useState(1)
	const [noOfQuestions, setNoOfQuestions] = useState(0)

	const [currentQuestion, setCurrentQuestion] = useState(null)
	const [answerDialogOpen, setAnswerDialogOpen] = useState(false)

	const handleChange = async (event, value) => {
		//setPage(value)
		if (value === page + 1 && questions.length < value * 5) {
			console.log(questions[questions.length - 1].id)
			const response = await adminGetQuestionsForApprovalV2({
				lastTimeStamp: firebaseTimeStampToDate(questions[questions.length - 1].createDateTime).getTime() + 1,
			})
			if (response.data.status === 0) {
				setQuestions((prevState) => [...prevState, ...response.data.questions])
				setPageCount(response.data.noOfPages)
			}
		}
		if (questions.length >= (value - 1) * 5 || questions.length === noOfQuestions) setPage(value)
	}
	const topFunction = () => {
		console.log(containerRef.current)
		containerRef.current.scroll(0, 0) // For Safari
		//document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	useEffect(() => {
		const _adminGetQuestionsForApproval = async () => {
			const response = await adminGetQuestionsForApprovalV2({})
			if (response.data.status === 0) {
				setQuestions(response.data.questions)
				setPageCount(response.data.noOfPages)
				setNoOfQuestions(response.data.noOfQuestions)
			}
		}
		if (page === 1 && questions.length === 0) {
			_adminGetQuestionsForApproval()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	/* useEffect(() => {
		console.log(questions)
	}, [questions])

	useEffect(() => {
		console.log(page)
	}, [page]) */

	const handleSort = (field) => {
		setSort((prevState) =>
			prevState.field === field ? { field: field, asc: !prevState.asc } : { field: field, asc: true }
		)
	}

	useEffect(() => {
		if (Object.keys(sort).length > 0) {
			setQuestions((prevState) =>
				[...prevState].sort((a, b) =>
					sort.asc && typeof a[sort.field] === "string"
						? a[sort.field].localeCompare(b[sort.field])
						: b[sort.field].localeCompare(a[sort.field])
				)
			)
		}
	}, [sort])

	const handleUpdateQuestionStatus = async (postId, questionId, status) => {
		try {
			await adminApproveDenyQuestionV2({ postId, questionId, status })
			handleOpenSnackbar("השאלה " + (status === "ACTIVE" ? "אושרה!" : "נדחתה!"), "success")
			setQuestions((prevState) => [...prevState].filter((question) => question.id !== questionId))
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון השאלה", "error")
		}
	}

	const handleAnswerQuestion = (question) => {
		setCurrentQuestion(question)
		setAnswerDialogOpen(true)
	}

	const renderPostValue = (type, value, index) => {
		switch (type) {
			case "text":
				return value
			case "datetime":
				return firebaseTimeStampToDate(value)?.toLocaleString("he")
			case "license":
				return (
					<Link
						target="_blank"
						sx={{ cursor: "pointer" }}
						onClick={() => handlePostOptionOpen(questions[index].postId, "ACTIVE")}
					>
						{formatLicenseNumber(value)}
					</Link>
				)
			case "currency":
				return "\u20aa" + new Intl.NumberFormat().format(parseInt(value))
			case "status":
				return statuses[value] ?? value
			case "userid":
				return (
					<Link target="_blank" sx={{ cursor: "pointer" }} onClick={() => handleUserDialogOpen(value)}>
						{value}
					</Link>
				)
			default:
				return value
		}
	}

	return (
		<ThemeProvider theme={mdTheme}>
			<AnswerQuestionDialog
				answerDialogOpen={answerDialogOpen}
				setAnswerDialogOpen={setAnswerDialogOpen}
				question={currentQuestion}
				setQuestions={setQuestions}
			/>
			{matches ? (
				<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
					<Typography variant="h6">שאלות לאישור</Typography>
					<Table
					/* sx={{
							tableLayout: "fixed",
							"th:nth-of-type(1), td:nth-of-type(1)": { width: "180px" },
							"th:nth-of-type(2), td:nth-of-type(2)": { width: "280px" },
						}} */
					>
						<TableHead>
							<TableRow>
								{questionCols.map((col) => (
									<TableCell
										key={col.field}
										variant="head"
										sx={{ fontWeight: 600, cursor: "pointer" }}
										onClick={() => {
											if (col.type !== "datetime") handleSort(col.field)
										}}
									>
										<div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
											{col.label}
											{sort.field === col.field ? (
												sort.asc ? (
													<FilterListIcon />
												) : (
													<FilterListIcon sx={{ transform: "rotate(180deg)" }} />
												)
											) : null}
										</div>
									</TableCell>
								))}
								<TableCell> </TableCell>
								<TableCell> </TableCell>
								<TableCell> </TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{questions
								.filter((e, i) => i >= (page - 1) * 5 && i < page * 5)
								.map((question, index, questions) => (
									<React.Fragment key={question.id}>
										<Slide direction="left" in={true} mountOnEnter unmountOnExit>
											<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
												{questionCols.map((col) => (
													<TableCell
														align={col.field === "licenseNumber" ? "center" : "left"}
														sx={{ wordWrap: "break-word" }}
														key={col.field}
													>
														{renderPostValue(col.type, question[col.field], index)}
													</TableCell>
												))}
												<TableCell>
													<Button
														variant="contained"
														sx={{ backgroundColor: mdTheme.palette.primary.main }}
														onClick={() => handleUpdateQuestionStatus(question.postId, question.id, "ACTIVE")}
													>
														אישור
													</Button>
												</TableCell>
												<TableCell>
													<Button
														variant="contained"
														sx={{ backgroundColor: mdTheme.palette.secondary.main }}
														onClick={() => handleUpdateQuestionStatus(question.postId, question.id, "CANCELLED")}
													>
														דחיה
													</Button>
												</TableCell>
												<TableCell>
													<Button
														variant="contained"
														sx={{ backgroundColor: "green" }}
														onClick={() => handleAnswerQuestion(question)}
													>
														מענה
													</Button>
												</TableCell>
											</TableRow>
										</Slide>
									</React.Fragment>
								))}
						</TableBody>
					</Table>
				</Paper>
			) : (
				<>
					<ScrollTopButton onClick={() => topFunction()}>
						<img style={{ width: "20px", height: "20px" }} src={scrollTopIcon} alt="Scroll To Top" />
					</ScrollTopButton>
					<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
						<Typography variant="h6">שאלות לאישור</Typography>
					</Paper>
					{questions
						.filter((e, i) => i >= (page - 1) * 5 && i < page * 5)
						.map((question, index) => (
							<React.Fragment key={question.id}>
								<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
									<Table sx={{ tableLayout: "fixed", width: "100%" }}>
										<TableBody>
											{questionCols.map((col) => (
												<TableRow key={col.field}>
													<TableCell variant="head" sx={{ fontWeight: 600 }}>
														{col.label}
													</TableCell>
													<TableCell sx={{ wordWrap: "break-word" }}>
														{renderPostValue(col.type, question[col.field], index)}
													</TableCell>
												</TableRow>
											))}
											<TableRow>
												<TableCell colSpan={2}>
													<Button
														variant="contained"
														sx={{ backgroundColor: mdTheme.palette.primary.main, ml: 0, mr: 1 }}
														onClick={() => handleUpdateQuestionStatus(question.postId, question.id, "ACTIVE")}
													>
														אישור
													</Button>
													<Button
														variant="contained"
														sx={{ backgroundColor: mdTheme.palette.secondary.main, ml: 0, mr: 1 }}
														onClick={() => handleUpdateQuestionStatus(question.postId, question.id, "CANCELLED")}
													>
														דחיה
													</Button>
													<Button
														variant="contained"
														sx={{ backgroundColor: "green", ml: 0, mr: 0 }}
														onClick={() => handleAnswerQuestion(question)}
													>
														מענה
													</Button>
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</Paper>
							</React.Fragment>
						))}
				</>
			)}
			<Pagination count={pageCount} page={page} onChange={handleChange} size={matches ? "medium" : "small"} />
		</ThemeProvider>
	)
}

export default Questions
